export type IdentifierMode = 'phone' | 'email';

export type IdentifierFieldConfig = {
	label: string;
	placeholder: string;
	type: string;
	inputmode: string;
	autocomplete: string;
	name: string;
	subtitle: string;
	toggleLabel: string;
	useAnotherLabel: string;
};

export function getIdentifierFieldConfig(mode: IdentifierMode): IdentifierFieldConfig {
	if (mode === 'email') {
		return {
			label: 'Email',
			placeholder: 'Email address',
			type: 'email',
			inputmode: 'email',
			autocomplete: 'email',
			name: 'email',
			subtitle: "We'll send a one-time code via email.",
			toggleLabel: 'Login with Whatsapp',
			useAnotherLabel: 'Use another email',
		};
	}

	return {
		label: 'Phone number',
		placeholder: 'Phone number',
		type: 'tel',
		inputmode: 'tel',
		autocomplete: 'tel',
		name: 'tel',
		subtitle: "We'll send a one-time code via WhatsApp.",
		toggleLabel: 'Login with Email',
		useAnotherLabel: 'Use another phone',
	};
}

export function toggleIdentifierMode(mode: IdentifierMode): IdentifierMode {
	return mode === 'phone' ? 'email' : 'phone';
}

export type PhoneHintFocusResult = {
	/** Prefill value when the field was still empty after a successful hint. */
	prefill?: string;
	hintAttempted: boolean;
};

/**
 * One-shot Android phone hint on focus of an empty phone-mode identifier.
 * Does not overwrite a non-empty identifier.
 */
export async function handlePhoneIdentifierFocus(options: {
	mode: IdentifierMode;
	identifier: string;
	hintAttempted: boolean;
	requestHint?: () => Promise<string | undefined>;
}): Promise<PhoneHintFocusResult> {
	const {
		mode,
		identifier,
		hintAttempted,
		requestHint = async () => undefined,
	} = options;

	if (mode !== 'phone' || hintAttempted || identifier.trim()) {
		return { hintAttempted };
	}

	const phoneNumber = await requestHint();
	if (phoneNumber && !identifier.trim()) {
		return { prefill: phoneNumber, hintAttempted: true };
	}

	return { hintAttempted: true };
}
